export default {
    _prefix: "RemainingCharacters",
    charactersRemaining: (data: { remaining: number; total: number }) =>
        "{{remaining}}/{{total}} characters remaining",
};
